import { render } from "./SummaryModel.vue?vue&type=template&id=449c74cb&scoped=true"
import script from "./SummaryModel.vue?vue&type=script&lang=js"
export * from "./SummaryModel.vue?vue&type=script&lang=js"

import "./SummaryModel.vue?vue&type=style&index=0&id=449c74cb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-449c74cb"]])

export default __exports__